import React from 'react';
import Accordian from 'atoms/Accordian/Accordian';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { TOPIC_QUESTION } from '../NutritionAllergenConstants/NutritionAllergenConstants';

const onClickHandler = e => {
  const accordian = e.target?.parentElement?.parentElement?.parentElement;
  accordian.classList.contains('nutrition-alleren-accordian-open')
    ? accordian.classList.remove('nutrition-alleren-accordian-open')
    : accordian.classList.add('nutrition-alleren-accordian-open');
};

export const NutritionAllergenInfoData = NutritionAllergenInfo => {
  return NutritionAllergenInfo?.map(item => {
    return (
      item?.sys?.contentType?.sys?.id === TOPIC_QUESTION && (
        <div className='nutrition-alleren-accordian'>
          <Accordian header={item?.fields?.question} onClickHandler={onClickHandler}>
            <div
              dangerouslySetInnerHTML={{
                __html: documentToHtmlString(item?.fields?.answer),
              }}
              className='nutrition-alleren-accordian-answer'
            />
          </Accordian>
        </div>
      )
    );
  });
};

const NutritionAllergenAccordian = ({ NutritionAllergenInfo }) => {
  return <div className='nutrition-alleren-accordian-desktop'>{NutritionAllergenInfoData(NutritionAllergenInfo)}</div>;
};

export default NutritionAllergenAccordian;
